// App.tsx
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/HomePage';
import Privacy from './pages/Privacy';
import Auth from './pages/Auth';

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        {/* Route for the homepage */}
        <Route path="/home" element={<Home />} />
        <Route path="/privacy" element={<Privacy />} />

        {/* Route for the auth success page */}
        <Route path="/auth" element={<Auth />} />

        {/* Optionally redirect from the root to /home */}
        <Route path="/" element={<Home />} />
      </Routes>
    </Router>
  );
}

export default App;
